module.exports = __webpack_public_path__ + "img/sy.a610efa2.svg";